export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["INTERNAL_SERVER_ERROR"] = "internalServerError";
    ErrorCode["INVALID_REQUEST"] = "invalidRequest";
    ErrorCode["INVALID_PARAMETER"] = "invalidParameter";
    ErrorCode["CALENDAR_NO_NAME"] = "calendarNoName";
    ErrorCode["CALENDAR_INVALID_DATE_RANGE"] = "calendarInvalidDateRange";
    ErrorCode["CALENDAR_INVALID_EXCEPTION_NAME"] = "calendarInvalidExceptionName";
    ErrorCode["CALENDAR_INVALID_EXCEPTION_OPENINGS"] = "calendarInvalidExceptionOpenings";
    ErrorCode["CALENDAR_INVALID_EXCEPTION_OPENING_BOUNDARY"] = "calendarInvalidExceptionOpeningBoundary";
    ErrorCode["CALENDAR_DATE_OVERLAP"] = "calendarDateOverlap";
    ErrorCode["CALENDAR_NOT_FOUND"] = "calendarNotFound";
    ErrorCode["CALENDAR_INVALID_NORMAL_OPENINGS"] = "calendarInvalidNormalOpenings";
    ErrorCode["CALENDAR_INVALID_EXCEPTIONS"] = "calendarInvalidExceptions";
    ErrorCode["CALENDAR_INVALID_EXCEPTION_DATE_ORDER"] = "calendarInvalidExceptionDateOrder";
    ErrorCode["CALENDAR_INVALID_EXCEPTION_DATE_BOUNDARY"] = "calendarInvalidExceptionDateBoundary";
})(ErrorCode || (ErrorCode = {}));
